<template>
    <Transition name="confirm">
        <div v-if="state.open" class="confirm-overlay" @click.self="settle(false)">
            <div class="confirm-box">
                <h2 v-if="state.title" class="confirm-title">{{ state.title }}</h2>
                <p class="confirm-message">{{ state.message }}</p>
                <div class="confirm-actions">
                    <button class="btn btn-ghost btn-block" @click="settle(false)">
                        {{ state.cancelLabel || $t('cancel') }}
                    </button>
                    <button
                        :class="['btn', 'btn-block', state.danger ? 'btn-danger' : 'btn-primary']"
                        @click="settle(true)"
                    >
                        {{ state.confirmLabel || $t('confirm') }}
                    </button>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script>
import { confirmState, settleConfirm } from '@/plugins/confirm.js';

export default {
    name: 'ConfirmDialog',
    data() {
        return { state: confirmState };
    },
    methods: {
        settle(value) {
            settleConfirm(value);
        }
    }
};
</script>

<style scoped>
.confirm-overlay {
    position: fixed;
    inset: 0;
    z-index: 90;
    background: rgba(28, 16, 8, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
}

.confirm-box {
    width: 100%;
    max-width: 380px;
    background: #fffaf4;
    border-radius: 22px;
    padding: 26px 22px 20px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.28);
}

.confirm-title {
    font-size: 19px;
    font-weight: 700;
    color: #2a1a0e;
    margin-bottom: 8px;
}

.confirm-message {
    font-size: 15px;
    line-height: 1.45;
    color: #6a584a;
    margin-bottom: 22px;
}

.confirm-actions {
    display: flex;
    gap: 10px;
}

.confirm-enter-active, .confirm-leave-active {
    transition: opacity .18s ease;
}

.confirm-enter-active .confirm-box, .confirm-leave-active .confirm-box {
    transition: transform .18s ease;
}

.confirm-enter-from, .confirm-leave-to {
    opacity: 0;
}

.confirm-enter-from .confirm-box, .confirm-leave-to .confirm-box {
    transform: scale(.94);
}
</style>
